import { inject } from '@angular/core';
import {
  CanActivateFn,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { KeycloakService } from '../services/keycloak.service';

export const canActivateAuthRole: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  __: RouterStateSnapshot
): boolean | UrlTree => {
  const keycloakService = inject(KeycloakService);
  const router = inject(Router);

  const requiredRole = route.data['role'];
  if (!requiredRole || !keycloakService.isAuthenticated()) {
    return router.parseUrl('/unauthorized');
  }

  const tokenParsed: any = keycloakService.getParsedToken();
  const roles: string[] = tokenParsed?.realm_access?.roles ?? [];

  console.log('Required Role:', requiredRole);
  // console.log('[Guard] User Roles:', roles);

  return roles.includes(requiredRole) ? true : router.parseUrl('/unauthorized');
};
